<div class="horizinns-container center">
    <div style="text-align: center; padding: 2rem;">
        <mat-card class="horizinns-card margin-auto mw-60">
            <mat-card-content>
                <img src="/assets/images/logo_full_900.png" class="main-logo" alt="Horizinns logo" />
                <h1>🥸 Unauthorized</h1>
                <h3>Sorry, you don't have permissions to access this page.</h3>
                <button mat-raised-button color="accent" routerLink="/">
                    <mat-icon matPrefix>home</mat-icon>
                    Home
                </button>
            </mat-card-content>
        </mat-card>
    </div>
</div>